import * as React from 'react';
type Props = {
  className?: string;
};
export function NoBellPepper({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoBellPepper"
      className={className}
    >
      <g clipPath="url(#clip0_146_1054)">
        <path
          d="M30.1848 18.3177C30.9177 18.3019 31.6482 18.4085 32.3461 18.6331L32.4393 9.73126H28.4324L28.3389 18.785C28.9268 18.5364 29.5493 18.3788 30.1848 18.3177V18.3177Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M26.8784 46.2617C25.7919 44.2406 23.8178 41.0865 23.0001 28.6215C22.8713 26.1266 23.5784 23.66 25.0094 21.6122C25.7275 20.445 26.7653 19.5083 27.9998 18.9135C28.14 18.8434 28.2686 18.8083 28.4088 18.7499C27.0888 17.8461 25.5587 17.2964 23.9652 17.1532C22.3718 17.01 20.7684 17.2782 19.3083 17.9322C16.2476 19.486 15.9674 22.9673 15.687 26.4369C15.2898 31.2967 16.6566 35.0584 18.3272 39.521C19.3202 42.1612 21.6681 48.8668 23.3386 50.035C23.778 50.2341 24.2484 50.3567 24.729 50.3972C26.13 50.4152 27.4875 49.9112 28.5375 48.9836C28.6939 48.8526 28.842 48.7122 28.9813 48.563C28.0661 48.0233 27.3336 47.2217 26.8784 46.2617Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M45.0095 25.257C44.367 21.8342 43.7129 18.3879 40.4886 17.0795C39.0192 16.5569 37.4424 16.4103 35.9018 16.6531C34.3613 16.8959 32.9059 17.5203 31.6685 18.4696C32.2276 18.585 32.7667 18.7818 33.2688 19.0537C35.465 20.2219 36.3064 22.7921 36.7036 23.9954C38.7596 30.2688 37.2877 44.159 33.783 47.944C34.0306 48.2132 34.309 48.4524 34.6124 48.6566C35.7401 49.5097 37.1387 49.9248 38.5492 49.8248C39.0197 49.7441 39.4738 49.5862 39.8928 49.3575C41.318 48.7617 43.0702 41.2617 43.7711 38.5514C44.9627 33.9253 45.9207 30.0701 45.0095 25.257Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M30.1847 18.3176C31.2767 18.288 32.3582 18.5372 33.3271 19.0419C35.5234 20.2101 36.3644 22.7803 36.7616 23.9836C38.9929 30.7827 37.0773 46.5419 32.9184 48.6797C31.8017 49.1228 30.5572 49.1189 29.4434 48.6686C28.3296 48.2183 27.4319 47.3563 26.937 46.2616C25.8505 44.2406 23.8761 41.0864 23.0584 28.6214C22.9296 26.1265 23.637 23.6599 25.068 21.6121C25.7861 20.4449 26.8239 19.5083 28.0584 18.9134C28.7221 18.5796 29.4441 18.3772 30.1847 18.3176V18.3176Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M11.7852 52.4533L19.6356 42.8972"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08398 30C1.08398 24.1816 2.80932 18.4939 6.04209 13.6562C9.27487 8.81857 13.8696 5.04829 19.2454 2.82222C24.6211 0.596144 30.5364 0.014204 36.2428 1.15017C41.9492 2.28614 47.1905 5.0889 51.3039 9.20396C55.4174 13.319 58.218 18.5615 59.3517 24.2684C60.4854 29.9753 59.9015 35.8903 57.6733 41.2651C55.4451 46.6399 51.6728 51.2332 46.8338 54.4641C41.9949 57.6949 36.3065 59.4182 30.4881 59.4159C22.6885 59.4128 15.2094 56.3124 9.69536 50.7961C4.18134 45.2799 1.08398 37.7995 1.08398 30"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.1426 17.278L49.215 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_1054">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
